import React, { Component } from 'react';
import './App.css';

class App extends Component {
  constructor(){
    super()
    this.state = {
      portFiles : [
        {name : "Книга рецептов", description : "Это приложение позволяет добавлять, изменять и удалять рецепты. Все изменения будут сохранены в localStorage",
        src : "recipe.PNG", href : "https://alexandrguzenko.github.io/recipe/"},
        {name :"Генератор цитат", description : "Приложение генерирует случайные цитаты, поднимающие настроение и придающие уверенность", 
        src : "quotes.PNG", href : "https://alexandrguzenko.github.io/apgradequotes/"},
        {name :"Крестики-нолики", description : "Популярная игра крестики-нолики, позволяющая играть как с компьютером (одиночная игра), так и с другом (1 на 1)",
        src : "tic_tac_toe.PNG", href : "https://alexandrguzenko.github.io/TicTacToe_game/"},
        {name :"Pomodoro clock", description : "Pomodoro clock - приложение, предназначенное для разбиение задач на периоды, сопровождающиеся коротким отдыхом", 
        src : "pomodoro.PNG", href : "https://alexandrguzenko.github.io/Pomodoro_clock/"},
        {name : "Twitch App", description : "Это приложение позволяет отслеживать активность некоторых Twitch каналов, наличие на них трансляций в настоящее время и, при наличии трансляции, указывает транслируемое событие",
        src : "twitch.PNG", href : "https://alexandrguzenko.github.io/twitch_app/"},
        {name :"Wiki viewer", description : "Приложение работает с wiki API и позволяет находить статьи из википедии по запросу и выводить первые 10", 
        src : "wikipedia.PNG", href : "https://alexandrguzenko.github.io/wiki_viewer/"},
        {name :"Игра про космос", description : "Простая игра, реализованная менее чем в 100 строках кода", 
        src : "game_space.png", href : "https://alexandrguzenko.github.io/game1/"}
      ]

    }
  }
  render() {
    return (
      <div className="row">
        <div className="col-lg-3 grey-3">
          <div className="block-name">
            <h3>Портфолио</h3>
            <p>Немного моего творчества</p>
          </div>
        </div>
        <div className="col-lg-9 grey-1">
          <div className="row">
          {this.state.portFiles.map((app,index)=> 

            <div className="col-lg-6" key={index}>
              <a href={app.href} target="_blank">
                <div className="port-img"> <img src={app.src} alt="" />
                  <div className="port-text">
                    <div className="text">
                      <h5>{app.name}</h5>
                      <p>{app.description}</p>
                    </div>
                  </div>
                </div>  
              </a>
            </div>

            )}
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js